// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2EcYr","upload":"Small_upload__1onST","imageWrap":"Small_imageWrap__27wk6","removeBtn":"Small_removeBtn__3XXQp"};